import React from 'react'
import LotteryResultSectionHeader from '../LotteryResultSectionHeader'

/**
 * Fallback section หวยออมสิน: ใช้เมื่อยังโหลดหรือไม่พบงวดหวยออมสิน
 * หวยธนาคารออกเป็นงวด ไม่ใช่รายวัน — วันที่ไม่มีงวดจะไม่มีรอบเลย จึงแสดงสถานะ
 * "ยังไม่เปิดรับแทงงวดถัดไป" แทน "รอผล" (กันเข้าใจผิดว่ากำลังรอผล) แต่การ์ดยังอยู่ ไม่หายไป
 */
const LotteryResultStaticGsb: React.FC = () => (
  <div className="col-12 col-lg-6 px-1 mb-4">
    <LotteryResultSectionHeader
      title="หวยออมสิน"
      iconUrl="flag/gsb.png"
      drawLabel="ยังไม่เปิดงวด"
    />
    <div className="wrap-box p-2 pt-0 bgg-6 bdr-5">
      <div className="row mx--1">
        <div className="col-12 px--1 mt-2 animateMe" data-animation="fadeInUp">
          <div className="bg-white bdr-5 bx-sd p-2 text-center">
            <div className="px-1 t-medium">
              <h5 className="mb-0">ยังไม่เปิดรับแทงงวดถัดไป</h5>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
)

export default LotteryResultStaticGsb
